// Dependencies
import React from 'react';
import { useSpring, animated } from 'react-spring';
import _ from 'lodash';
import { Helpers } from '../../utils';

// Types
import { Components } from "../../types";
import styled, { css, useTheme } from 'styled-components'; 

// TODO: Refactor, optimise
export const Price = ({price, taxClass, taxable, pricePerUnitThreshold = -1, quantity, config: {general: {decimals, tax, currency, roundingPrecision}}, translations}: any) => {

    const { components }: any = useTheme();
    
    const priceArgs = {
        quantity,
        displayMode: _.isBoolean(taxable) ? (taxable ? 'include' : 'exclude') : null ?? tax.displayMode,
        taxClass: taxClass ?? tax.default,
        taxRates: tax.rates,
        precision: Math.abs(roundingPrecision),
        isOnSale: price?.sale && price.sale < price.regular
    }
//price?.sale && price.sale < price.regular ? price.regular : null, 
    // TODO: Refactor, optimise
    const springs = useSpring({ 
        newPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs, quantity: 1}) || 0,
        oldPrice: (priceArgs.isOnSale) ? Helpers.getPrice({price: price.regular, ...priceArgs, quantity: 1}) : 0 || 0, 
        currentPrice: Helpers.getPrice({price: priceArgs.isOnSale ? price.sale : price.regular, ...priceArgs}) || 0,
        currentOldPrice: (priceArgs.isOnSale) && price.regular ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0 || 0,
        from: { 
            oldPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.sale, ...priceArgs}) : 0,  
            newPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0,
            currentOldPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.sale, ...priceArgs}) : 0,  
            currentPrice: priceArgs.isOnSale ? Helpers.getPrice({price: price.regular, ...priceArgs}) : 0,
        },
        config: {
            duration: components.price.animationDuration
        }
    })  

    if ( ! price?.regular && ! price?.sale ) {
        return null;
    }
 
    // TODO: Pad zeros when they should be there (resets when some state changes) > 19.00 >> 19
    const getFormattedPrice = (type: 'oldPrice' | 'newPrice' | 'currentPrice' | 'currentOldPrice') => springs[type].to((price: number) => Helpers.getRoundedPrice(price, priceArgs.precision).toFixed(decimals));

    return ( 
        <PriceWrapper>
            {price?.sale && price.sale < price.regular && 
                <DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('currentOldPrice') }</DisplayPrice>
            }
            <DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('currentPrice') }</DisplayPrice>

            { pricePerUnitThreshold > 0 &&
                <PricePerUnit visible={quantity > 1}>
                    <div>
                        <strong>{`${translations.product.pricePerUnit}: `}</strong>
                        {price?.sale && price.sale < price.regular && <DisplayPrice {...{type: 'original', currency}}>{ getFormattedPrice('oldPrice') }</DisplayPrice> }
                        <DisplayPrice {...{type: 'current', currency}}>{ getFormattedPrice('newPrice') }</DisplayPrice>
                    </div>
                </PricePerUnit>
            }

        </PriceWrapper>
    )
}

// TODO: Universal price display (type, value, currency, animated, ...)

export const PriceWrapper = styled.div<any>(
({ theme: { general, components: {price: style} } }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    text-align: right;
    font-size: 100%;
`);

export const CurrentPrice = styled.ins<any>(
({ theme: { general, components: {price: style} } }) => css`
    ${Helpers.clamp('font-size', 1.625, 2.75)};
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    color: ${style.primaryTextColor};
    
`);

// TODO:         min-width: ${3 + 1 + 1 + decimals}ch; // Space for [000].[00]€
export const OriginalPrice = styled.del<any>(
({ theme: { general, components: {price: style} } }) => css`
    ${Helpers.clamp('font-size', 1, 1.5, 2.5)};
    line-height: 1;
    font-weight: 400;
    color: ${style.secondaryTextColor};
`);

export const PricePerUnit = styled.small<any>(
({ visible, theme: { general, components: {price: style} } }) => css`
    position: absolute;
    bottom: ${-1 * (0.5 + 1)}em; // line-height + spacing-top
    right: 0;
    width: 100%;
    overflow: hidden;
    ${Helpers.clamp('font-size', 0.75, 0.95, 3.5)};

    div {
        width: fit-content;
        display: inline-block;
        opacity: ${visible ? 1 : 0};
        transform: translateX(${visible ? 0 : 100}%);
        transition: all ${general.transition.duration} ${general.transition.timingFunction};
    }
    
    strong {
        font-weight: 400;
        margin-right: .15em;
    }
    
    ${OriginalPrice} {
        font-size: 1em;
        color: ${style.secondaryTextColor};
        margin-right: 0.25em;
    }

    ${CurrentPrice} {
        font-size: 1em;
        color: ${style.primaryTextColor};
        text-decoration: none;
    }
`);

export const CurrencySymbol = styled.span<any>(
    ({ position, theme: { general, components: {price: style} } }) => css`
    ${`margin${position === 'before' ? 'left' : 'right'}`}: 0.25em;
`)

const priceDisplayMap: any = {
    current: CurrentPrice,
    original: OriginalPrice
}

export const DisplayPrice = ({type, children, currency: {position, symbol}}: any) => {

    const PriceWrapper = React.useMemo(() => (type in priceDisplayMap) ? priceDisplayMap[type] : priceDisplayMap.current, [type]);

    return (
        <PriceWrapper>
            {symbol && position === 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
            <animated.span>{ children }</animated.span>
            {symbol && position !== 'before' && <CurrencySymbol {...{position}}>{symbol}</CurrencySymbol>}
        </PriceWrapper>
    )

}